import {
  firstRealImageUrl,
  productHasNoRealMedia,
  urlLooksLikeDeferredAdminPlaceholder,
} from './adminMediaPlaceholder';

function hasValidStorefrontSlug(slug) {
  return typeof slug === 'string' && slug.trim().length > 0;
}

/** Price must be a finite number strictly greater than 0 (handles string decimals from JSON). */
export function hasPositiveDisplayPrice(price) {
  if (price == null) return false;
  const n = Number(price);
  return Number.isFinite(n) && n > 0;
}

/**
 * Earlier this gate used `productUsesDeferredMediaPlaceholders`, which
 * returned true the moment ANY single field was a placeholder. A product
 * with 5 real photos + 1 leftover placeholder anywhere — e.g. on a stale
 * `thumbnail` field — got hidden from shoppers entirely. The relaxed check
 * keeps a product visible as long as at least one real image exists; the
 * thumbnail rewrite below makes sure the card never renders the placeholder.
 */
export function isProductDisplayableOnStorefront(p) {
  if (!p || typeof p !== 'object') return false;
  return (
    hasPositiveDisplayPrice(p.price) && hasValidStorefrontSlug(p.slug) && !productHasNoRealMedia(p)
  );
}

/**
 * Shop grid / carousels: only rows that are safe to link to /product/:slug and show a real price.
 * (Defense in depth on top of API `catalogOnly` + EN_VENTA.)
 *
 * Also normalizes `thumbnail` so a placeholder thumbnail is replaced by the
 * first real image found on productResources / colorOptions — the card layer
 * never has to know about placeholders.
 */
export function filterProductsForStorefrontCatalog(products) {
  if (!Array.isArray(products)) return [];
  return products.filter(isProductDisplayableOnStorefront).map((p) => {
    if (urlLooksLikeDeferredAdminPlaceholder(p?.thumbnail)) {
      const fallback = firstRealImageUrl(p);
      if (fallback && fallback !== p.thumbnail) {
        return { ...p, thumbnail: fallback };
      }
    }
    return p;
  });
}
